function setTabs() {
    const tabsNavItems = document.querySelectorAll('.tabs .tabs__nav-item');
    const tabs = document.querySelectorAll('.tabs .tabs__item');

    tabsNavItems.forEach(navItem => {
        navItem.addEventListener('click', () => {
            tabsNavItems.forEach(item =>
                item.classList.remove('tabs__nav-item_active')
            );
            navItem.classList.add('tabs__nav-item_active');
            tabs.forEach(item => item.classList.remove('tabs__item_active'));
            const newActiveTab = [...tabs].find(
                item => `#${item.id}` === navItem.dataset.target
            );
            newActiveTab.classList.add('tabs__item_active');
        });
    });
}

function createSliders() {
    const sliderThumbs = new Swiper(
        '.product__slider .thumbs .swiper-container',
        {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 10
        }
    );

    new Swiper('.product__slider .main', {
        pagination: {
            el: '.product__slider .slider__dots',
            bulletClass: 'slider__dot',
            bulletActiveClass: 'slider__dot_active'
        },
        navigation: {
            prevEl: '.product__slider .slider__arrow_prev',
            nextEl: '.product__slider .slider__arrow_next'
        },
        thumbs: {
            swiper: sliderThumbs
        },
        breakpoints: {
            600: {
                allowTouchMove: false
            }
        }
    });

    new Swiper('.similar-products__slider .swiper-container', {
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 30,
        navigation: {
            prevEl: '.similar-products__slider .slider__arrow_prev',
            nextEl: '.similar-products__slider .slider__arrow_next',
            disabledClass: 'slider__arrow_disabled'
        },
        breakpoints: {
            960: {
                allowTouchMove: false,
                slidesPerView: 2,
                slidesPerGroup: 2,
                freeMode: false
            }
        }
    });
}

setTabs();
createSliders();
